"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchAppMounted = watchAppMounted;
exports["default"] = allSagas;

var _effects = require("redux-saga/effects");

var _AuthSagas = _interopRequireDefault(require("../../modules/auth/AuthSagas"));

var _AppActions = require("./AppActions");

var _AuthActions = require("../../modules/auth/AuthActions");

var _ConfigModel = _interopRequireDefault(require("../model/ConfigModel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(appMounted),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(watchAppMounted),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(allSagas);
/**
 * Logout user
 *
 * @param {Object} action
 */


function appMounted(action) {
  var token;
  return _regeneratorRuntime.wrap(function appMounted$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _ConfigModel["default"].load();

        case 3:
          token = window.localStorage.getItem('AUTH_TOKEN');

          if (!token) {
            _context.next = 7;
            break;
          }

          _context.next = 7;
          return (0, _effects.put)({
            type: _AuthActions.MEMBER_TOKEN_LOADED,
            payload: token
          });

        case 7:
          _context.next = 11;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 9]]);
}

function watchAppMounted() {
  return _regeneratorRuntime.wrap(function watchAppMounted$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_AppActions.APP_MOUNTED, appMounted);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function allSagas() {
  return _regeneratorRuntime.wrap(function allSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.all)([(0, _effects.fork)(watchAppMounted), (0, _effects.fork)(_AuthSagas["default"])]);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}